import type { CrmMessages } from "./englishCrmMessages";

export const portugueseFinanceMessages = {
  title: "Financeiro",
  admin_only:
    "O financeiro está disponível apenas para os administradores do time.",
  filters: "Filtros rápidos",
  search: "Buscar",
  none: "Nenhum",
  empty_filtered: "Nada corresponde a estes filtros.",
  tabs: {
    overview: "Visão geral",
    contracts: "Contratos",
    charges: "A receber",
    expenses: "Despesas",
  },
  fields: {
    company: "Empresa",
    amount: "Valor",
    description: "Descrição",
    competence_month: "Mês de competência",
    competence_month_help: "Mês ao qual o valor pertence (qualquer dia dele)",
    due_date: "Vencimento",
    paid_at: "Pago em",
    status: "Status",
    notes: "Observações",
  },
  months: {
    1: "Janeiro",
    2: "Fevereiro",
    3: "Março",
    4: "Abril",
    5: "Maio",
    6: "Junho",
    7: "Julho",
    8: "Agosto",
    9: "Setembro",
    10: "Outubro",
    11: "Novembro",
    12: "Dezembro",
  },
  payment_methods: {
    pix: "Pix",
    boleto: "Boleto",
    transfer: "Transferência",
    card: "Cartão",
    other: "Outro",
  },
  generate: {
    label: "Gerar o mês",
    done: "%{charges} cobrança(s) e %{expenses} despesa(s) criadas",
    nothing: "O mês já está gerado",
  },
  contracts: {
    create: "Novo contrato",
    create_from_deal: "Criar contrato",
    edit: "Editar contrato",
    created: "Contrato criado",
    updated: "Contrato atualizado",
    deleted: "Contrato excluído",
    empty: "Nenhum contrato ainda. Crie um a partir de um deal ganho ou aqui.",
    per_month: "%{amount} / mês",
    views: {
      active: "Ativos",
      paused: "Pausados",
      cancelled: "Cancelados",
      all: "Todos",
    },
    statuses: {
      active: "Ativo",
      paused: "Pausado",
      cancelled: "Cancelado",
    },
    adjustment_indexes: {
      none: "Sem reajuste",
      ipca: "IPCA",
      igpm: "IGP-M",
      fixed: "Taxa fixa",
    },
    fields: {
      name: "Nome do contrato",
      deal: "Negócio",
      setup_amount: "Implantação",
      setup_amount_help: "Valor único pago para começar o projeto",
      setup_installments: "Parcelas da implantação",
      monthly_amount: "Mensalidade",
      billing_day: "Dia de cobrança (1-28)",
      start_date: "Início",
      end_date: "Fim",
      adjustment_index: "Reajuste anual",
      adjustment_month: "Mês do reajuste",
    },
  },
  charges: {
    create: "Nova cobrança",
    edit: "Editar cobrança",
    created: "Cobrança criada",
    updated: "Cobrança atualizada",
    deleted: "Cobrança excluída",
    cancel: "Cancelar cobrança",
    cancelled: "Cobrança cancelada",
    restore: "Restaurar cobrança",
    restored: "Cobrança restaurada",
    mark_sent: "Marcar como enviada",
    marked_sent: "Cobrança marcada como enviada",
    register_payment: "Registrar pagamento",
    payment_registered: "Pagamento registrado",
    no_contract: "Sem contrato (avulsa)",
    empty:
      "Nenhuma conta a receber ainda. Gere o mês para criar as cobranças dos contratos.",
    count: "%{smart_count} cobrança |||| %{smart_count} cobranças",
    views: {
      open: "Em aberto",
      overdue: "Vencidas",
      due_soon: "Vencem em 7 dias",
      not_sent: "Não enviadas",
      no_invoice: "Pagas sem NF",
      this_month: "Este mês",
      paid: "Pagas",
      all: "Todas",
    },
    statuses: {
      pending: "A enviar",
      sent: "Enviada",
      overdue: "Vencida",
      paid: "Paga",
      cancelled: "Cancelada",
    },
    kinds: {
      recurring: "Mensalidade",
      setup: "Implantação",
      one_off: "Avulsa",
    },
    fields: {
      contract: "Contrato",
      kind: "Tipo",
      sent_at: "Enviada em",
      paid_amount: "Valor recebido",
      payment_method: "Forma de pagamento",
      invoice: "NF",
      invoice_number: "Número da NF",
      invoice_files: "Arquivos da NF (PDF / XML)",
      receipt_files: "Comprovantes de pagamento",
    },
  },
  expenses: {
    title: "Contas a pagar",
    create: "Nova despesa",
    edit: "Editar despesa",
    created: "Despesa criada",
    updated: "Despesa atualizada",
    deleted: "Despesa excluída",
    mark_paid: "Marcar como paga",
    marked_paid: "Despesa marcada como paga",
    empty: "Nenhuma despesa ainda.",
    views: {
      open: "A pagar",
      due_soon: "Vencem em 7 dias",
      this_month: "Este mês",
      paid: "Pagas",
      all: "Todas",
    },
    statuses: {
      to_pay: "A pagar",
      late: "Atrasada",
      paid: "Paga",
    },
    categories: {
      infrastructure: "Infraestrutura",
      payroll: "Folha de pagamento",
      tools: "Ferramentas / SaaS",
      taxes: "Impostos",
      marketing: "Marketing",
      accounting: "Contabilidade",
      other: "Outros",
    },
    fields: {
      category: "Categoria",
      supplier: "Fornecedor",
      files: "NF / comprovantes",
    },
  },
  recurring: {
    title: "Despesas recorrentes",
    help: 'Criadas todo mês por "Gerar o mês".',
    create: "Nova despesa recorrente",
    edit: "Editar despesa recorrente",
    created: "Despesa recorrente criada",
    updated: "Despesa recorrente atualizada",
    deleted: "Despesa recorrente excluída",
    empty:
      "Nenhuma despesa recorrente ainda (hospedagem, salários, ferramentas...).",
    total: "Custo fixo mensal: %{amount}",
    due_day: "vence dia %{day}",
    inactive: "Inativa",
    fields: {
      due_day: "Dia de vencimento (1-28)",
      active: "Ativa",
    },
  },
  alerts: {
    title: "Precisa de atenção",
    none: "Nada a fazer: tudo em dia.",
    severities: {
      error: "Urgente",
      warning: "Atenção",
      info: "Informação",
    },
    kinds: {
      overdue:
        "%{smart_count} cobrança vencida |||| %{smart_count} cobranças vencidas",
      due_soon:
        "%{smart_count} cobrança vence em 7 dias |||| %{smart_count} cobranças vencem em 7 dias",
      not_generated:
        "%{smart_count} cobrança do mês não gerada |||| %{smart_count} cobranças do mês não geradas",
      not_sent:
        "%{smart_count} cobrança ainda não enviada |||| %{smart_count} cobranças ainda não enviadas",
      paid_without_invoice:
        "%{smart_count} pagamento sem NF |||| %{smart_count} pagamentos sem NF",
      expenses_due:
        "%{smart_count} despesa a pagar |||| %{smart_count} despesas a pagar",
      adjustment_due:
        "%{smart_count} contrato para reajustar este mês |||| %{smart_count} contratos para reajustar este mês",
    },
  },
  overview: {
    empty:
      "Ainda não há dados financeiros. Crie um contrato (implantação + mensalidade) para ver sua receita previsível.",
    error: "Não foi possível carregar os dados financeiros.",
    truncated:
      "Registros demais: só os 1000 primeiros de uma lista foram usados, alguns números estão parciais.",
    no_data: "Sem dados no período",
    show_table: "Ver como tabela",
    month: "Mês",
    count: "Quantidade",
    share: "Participação",
    other: "Outros",
    days_late: "Dias de atraso",
    charges_count: "%{smart_count} cobrança |||| %{smart_count} cobranças",
    share_of_mrr: "%{share} do MRR",
    aging: {
      "1_15": "1-15 dias",
      "16_30": "16-30 dias",
      "31_60": "31-60 dias",
      "61_plus": "60+ dias",
    },
    series: {
      mrr: "MRR",
      billed: "Faturado",
      received: "Recebido",
      expenses_paid: "Despesas pagas",
      net: "Resultado",
      recurring: "Mensalidades e avulsas",
      setup: "Implantação",
      overdue: "Em atraso",
    },
    charts: {
      mrr: "Receita recorrente mensal",
      mrr_help: "Soma das mensalidades dos contratos ativos",
      billed_received: "Faturado x recebido",
      billed_received_help: "Cobranças do mês x pagamentos recebidos nele",
      result: "Receita, despesas e resultado",
      result_help: "Entradas e saídas de caixa de cada mês",
      mix: "Composição da receita",
      mix_help: "Recebido: receita recorrente x implantações",
      forecast: "Previsão dos próximos 6 meses",
      forecast_help: "Contratos ativos e parcelas de implantação restantes",
      aging: "Inadimplência por tempo de atraso",
      aging_help: "Cobranças não pagas após o vencimento",
      expenses: "Despesas por categoria",
      expenses_help: "Últimos 12 meses",
      concentration: "Concentração de receita",
      concentration_help: "MRR dos 10 maiores clientes",
    },
    kpis: {
      mrr: "MRR",
      vs_last_month: "vs mês passado",
      received: "Recebido no mês",
      of_billed: "de %{amount} faturado",
      overdue: "Em atraso",
      delinquency:
        "%{smart_count} cobrança · %{rate} do valor vencido |||| %{smart_count} cobranças · %{rate} do valor vencido",
      net: "Resultado do mês",
      margin: "margem %{margin}",
      expenses: "Despesas do mês",
      expenses_paid: "%{amount} já pagos",
      arpa: "Ticket médio",
      active_clients:
        "%{smart_count} cliente ativo |||| %{smart_count} clientes ativos",
      setup_to_receive: "Implantação a receber",
      active_contracts:
        "%{smart_count} contrato ativo |||| %{smart_count} contratos ativos",
      concentration: "Maior cliente",
      concentration_help: "participação no MRR",
    },
  },
} satisfies CrmMessages["crm"]["finance"];
